// extracted by mini-css-extract-plugin
export var section = "hero-module--section--1plOy";
export var head = "hero-module--head--14w-q";
export var title = "hero-module--title--21EOE";
export var subtitle = "hero-module--subtitle--2txOH";
export var info = "hero-module--info--11oZE";
export var info_tags = "hero-module--info_tags--CwyeG";
export var info_readTime = "hero-module--info_readTime--TA2BQ";
export var tagsList = "hero-module--tagsList--2kagW";